module.exports = __webpack_public_path__ + "media/images/icons/icon-remove-red-eye-a2442691d1be162fe3026627db5a809a.png";